import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, type User } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Same production project the Roadrunner site uses for Case-Studies logos.
const firebaseConfig = {
  apiKey: 'AIzaSyBEHMSaDMfwDhwTPc7W2ah_xDHee0J3ZiA',
  authDomain: 'roadrunner-native-web.firebaseapp.com',
  projectId: 'roadrunner-native-web',
  storageBucket: 'roadrunner-native-web.appspot.com',
  messagingSenderId: '882524352816',
  appId: '1:882524352816:web:48b66b794d07bb4e9718f5',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);

let authPromise: Promise<User> | null = null;

export async function initializeAuth(): Promise<User> {
  if (auth.currentUser) {
    await auth.currentUser.getIdToken();
    return auth.currentUser;
  }

  if (!authPromise) {
    authPromise = signInAnonymously(auth)
      .then(async (credential) => {
        await credential.user.getIdToken();
        return credential.user;
      })
      .catch((error) => {
        authPromise = null;
        throw error;
      });
  }

  return authPromise;
}
